export default {
    aboutPageTitle: "About LinguaScore",
    aboutPageDescription: "We help learners achieve their best scores on language proficiency exams through " +
        "structured practice, realistic mock tests and clear progress tracking.",
    ourMissionTitle: "Our Mission",
    ourMissionDescription: "LinguaScore exists to make high-quality language test preparation accessible and effective. Whether you&apos;re aiming for IELTS, TOEFL, TCF France or TCF Canada, we " +
        "provide the tools — mock tests, resources and analytics — so you can prepare with confidence and reach your target score.",
    whatWeStandForTitle:"What we stand for",
    whatWeStandForDescription:"What we stand for",
    aboutFeatures1Title: "Quality Content",
    aboutFeatures1Description: "Our practice materials and mock tests are designed to mirror real exam format and difficulty.",
    aboutFeatures2Title: "Clear progress",
    aboutFeatures2Description: "Track your performance with analytics and insights so you know where to focus.",
    aboutFeatures3Title: "Structured Learning",
    aboutFeature3Description: "From study notes to full-length tests, everything you need in one place.",
    aboutFeatures4Title: "Built for Success",
    aboutFeatures4Description: "We focus on IELTS, TOEFL, TCF France and TCF Canada so we do it well."
}